import { zodResolver } from '@hookform/resolvers/zod';
import { Check } from 'lucide-react';
import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
import { useCreateDokumenttyp } from '@/adapter/opm-cockpit-backend/useEventDokumentTypMappings';
import { Button } from '@/components/ui/button';
import { getErrResponseDetail, getOnSaveErrorMessage } from '@/lib/utils';
import { AnmerkungenBox } from '@/pages/Konfiguration/DokumentTypen/components/AnmerkungenBox';
import {
  CreateMappingRulesBox,
  mappingValuesToPayload,
} from '@/pages/Konfiguration/DokumentTypen/components/CreateMappingRulesBox';
import { DokumentTypBaseFieldsBox } from '@/pages/Konfiguration/DokumentTypen/components/DokumentTypBaseFieldsBox';
import {
  DEFAULT_DOKUMENTTYP_FORM_VALUES,
  DokumentTypFormInput,
  dokumentTypErstellenSchema,
} from '@/pages/Konfiguration/DokumentTypen/schemas/dokumenttypenerstellen';
import { ErrorMessage } from '@/pages/VorgangBearbeitung/components';
import { ActionButton } from '@/pages/VorgangBearbeitung/components/ActionButton';

export const CreateDokumentTypBox: React.FC = () => {
  const form = useForm<DokumentTypFormInput>({
    resolver: zodResolver(dokumentTypErstellenSchema),
    defaultValues: DEFAULT_DOKUMENTTYP_FORM_VALUES,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = form;

  const [showCreateBox, setShowCreateBox] = useState(false);
  const [err, setErr] = useState<unknown>();

  const createDokumenttyp = useCreateDokumenttyp();

  const onSubmitDokumenttypErstellen = (values: DokumentTypFormInput) => {
    createDokumenttyp.mutate(
      {
        dokumentTyp: values.dokumentTyp,
        eventName: values.eventName,
        eventTyp: values.eventTyp,
        aktiviert: true,
        ...mappingValuesToPayload(values),
      },
      {
        onSuccess: () => {
          setErr(null);
          setShowCreateBox(false);
          reset();
        },
        onError: (err: unknown) => {
          setErr(err);
        },
      },
    );
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-text-primary">
          Dokumenttypen
        </h2>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowCreateBox((s) => !s)}
          >
            {showCreateBox ? 'Abbrechen' : 'Neuen Dokumenttyp erstellen'}
          </Button>
        </div>
      </div>

      {showCreateBox && (
        <form
          onSubmit={handleSubmit(onSubmitDokumenttypErstellen)}
          className="space-y-4 mt-3"
        >
          <div className="p-4 border border-table-border rounded-md bg-white">
            <DokumentTypBaseFieldsBox register={register} errors={errors} />
          </div>

          <CreateMappingRulesBox form={form} />

          <AnmerkungenBox form={form} />

          <div className="flex justify-end">
            <ActionButton
              type="submit"
              loading={createDokumenttyp.isPending}
              loadingText="Erstellen..."
              normalText="Erstellen"
              icon={Check}
              variant="default"
            />
          </div>
        </form>
      )}
      {err && (
        <div>
          <ErrorMessage
            errorMessage={getErrResponseDetail(err)}
            errorList={getOnSaveErrorMessage(err)}
          />
        </div>
      )}
    </>
  );
};
